// Localstorage set and get

const storage = {
    set(key, value) {
        try {
            const data = typeof value === 'string' ? value : JSON.stringify(value);
            localStorage.setItem(key, data);
        } catch (err) {
            console.error('Storage set error:', err);
        }
    },

    get(key) {
        try {
            const value = localStorage.getItem(key);
            try {
                return JSON.parse(value);
            } catch {
                return value;
            }
        } catch (err) {
            console.error('Storage get error:', err);
            return null;
        }
    },

    remove(key) {
        localStorage.removeItem(key);
    },

    clear() {
        localStorage.clear();
    },
};

export default storage;
